export const VEHICLE_REGISTRATION_ROUTE = 'rejestracja-pojazdu';
